export enum ChangeLogSection {
  Companies = 'COMPANIES',
  Operators = 'OPERATORS',
  General = 'GENERAL',
  UserManagement = 'USER_MANAGEMENT',
  ThirdParty = 'THIRD_PARTY',
  PlayerAuth = 'PLAYER_AUTH',
  QuickTool = 'QUICK_TOOL',
}
